
<template>
    <form @submit.prevent="submit">
        <div class="row">
            <div v-if="!submited" class="form col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
                <div class="form-group">
                    <input class="form-control"
                           type="text"
                           placeholder="Full name *"
                           name="name"
                           id="name"
                           v-model="fields.name">
                     <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0]}}</div>
                </div>
                <div class="form-group">
                    <input class="form-control"
                           type="text"
                           placeholder="E-mail *"
                           name="email"
                           id="email"
                           v-model="fields.email">
                    <div v-if="errors && errors.email" class="text-danger">{{ errors.email[0]}}</div>
                </div>
                <div class="form-group">
                    <input class="form-control"
                           type="text"
                           placeholder="Company *"
                           name="company"
                           id="company"
                           v-model="fields.company">
                    <div v-if="errors && errors.company" class="text-danger">{{ errors.company[0] }}</div>
                </div>
                <!-- <div class="form-group">
                    <input class="form-control"
                           type="text"
                           placeholder="Phone number"
                           name="phone"
                           id="phone"
                           v-model="fields.phone">
                </div> -->
                <div class="from-group">
                    <select
                            class="form-control mb-0"
                            v-model="fields.selectedOption"
                            id="selected-option"
                            name="selectedOption"
                            >
                        <option value="" class="placeholder" disabled selected>Select an option *</option>
                        <option v-for="option in options" :key="option.text" >{{option.text}}</option>

                    </select>
                    <div v-if="errors && errors.selectedOption" class="text-danger">{{ errors.selectedOption[0]}}</div>
                </div>

                <div class="form-group mt-4">
                    <textarea
                        id="message"
                        name="message"
                        rows="5"
                        class="form-control"
                        v-model="fields.message"
                        placeholder="What can we help you with? *"></textarea>
                    <div v-if="errors && errors.message" class="text-danger">{{ errors.message[0] }}</div>
                </div>

                <button class="send-btn">Send Message</button>
                <div v-if="tooMany" class="text-danger text-center mt-4">{{ tooMany }}</div>

              </div>
              <div v-if="submited" class="message col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
                  <div class="message-content">
                    <p>Thanks for reaching out :)</p>
                    <img src='img/msg-sent.svg' alt="">
                    <p>We'll get in touch soon!</p>
                  </div>

              </div>
        </div>

    </form>

</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            fields: {selectedOption:''},
            errors: {},
            options:[
                {text:'Questions about using Infinity'},
                {text:'Questions about pricing'},
                {text:'Help with choosing a plan'},
                {text:'I’d like a demo'},
                {text:'Interested in enterprise plan'},
                {text:'Refund'},
                {text:'Other'}
            ],
            submited:false,
            tooMany: null
        };
    },
    mounted() {
        if (window.location.search.includes('enterprise')) {
            this.fields.selectedOption = 'Interested in enterprise plan';
        }
    },
    methods: {
        submit() {
            this.errors = {};
            this.tooMany = null;
            axios.post('/contact-submit', this.fields).then(() => {
                if (this.fields.selectedOption === 'Refund') {
                    dataLayer.push({'event': 'Refund Email Sent'});
                }
                this.fields={selectedOption:''};
                this.submited=true;

            }).catch(error => {
                if(error.response.status === 429) {
                    this.tooMany = error.response.data.message;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        },
    },
};
</script>

<style scoped>
   form{
       padding-bottom: 10px;
   }
   .form{
     padding-top:40px;
     margin:0 auto;
     border: 1px solid #E5E5E5;
     border-radius: 10px;
     background-color: #FEFEFE;
     margin-top: 40px;
     padding-left: 40px;
     padding-right: 40px;
     padding-bottom: 30px;
}

.form-control::placeholder{
    color:#9293A3;
}
input[type="text"]{
  height:40px;
  outline:none;
}
textarea{
  height:120px;
  outline:none;
}
select{
  height:40px;
  margin-bottom:30px;
  outline:none;
  color:#9293A3;
}
.form-control{
    border:1px solid #DADADA;
    background: white;
    font-size: 16px;
    line-height: 19px;
}
.form-group{
    margin-bottom:30px;
    outline: none;
}
.form-group:focus{
     outline: none;

}
.form-control:focus{
    border:1px solid #1BA7E0;
}

.send-btn{
    color: white;
    padding: 8px 20px;
    cursor: pointer;
    display: block;
    margin: 0 auto;
    font-size: 18px;
    line-height: 21px;
    border-radius: 3px;
    background-color: #2795FF;
    border:none;
}
.send-btn:active{
    outline:none;
}
.send-btn:focus{
    outline:none;
}
.message{
    border-radius: 10px;
    border: 1px solid #E5E5E5;
    background-color: #FEFEFE;
    box-shadow: 0 2px 0 0 rgba(0,0,0,0.1);
    margin:0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px
}
.message-content{
    margin-top:184px;
    margin-bottom: 184px;
    color:black;
}
.message-content p{
    font-size: 22px;
    line-height: 26px;
}
.message-content img{
    display: block;
    margin-bottom: 32px;
}


 </style>






// WEBPACK FOOTER //
// resources/js/frontend/components/ContactForm.vue